export const CategoryGroupIds = {
    // LeadQualifiedReason: 25,
    // LeadUnQualifiedReason: 26,
    // LeadActiveReason: 192,
    // LeadInactiveReason: 193,

    // ContactActiveReason: 190,
    // ContactInactiveReason: 191,

    // AccountActiveReason: 10,
    // AccountInactiveReason: 11,

    OpportunityCloseWonReason: 13,
    OpportunityCloseLostReason: 12,
    // OpportunityActiveReason: 8,
    // OpportunityInactiveReason: 9,
    OpportunityForeCastCategory: 6,

    CaseCategoryTicketAPI: 1
}

export const StatusGroupIds = {
    LeadStatusGroupId: 23,
    // ActiveInactivestatus: 6,
    // RelationshipStatus: 13,
    // MaritialStatus: 14,
    TaskStatusGroupId: 3
}

export const TypeGroupIds = {
    LeadTypeLeadAPI: 23,
    // ContactTypeContactAPI: 14,
    ContactAssociationType: 15,
    ContactType: 16,
    JobFuctionsContactAPI: 19,
    AccountTypeAccountAPI: 1,
    QuestionaireTypeOrganizationAPI: 4,
    AddressTypeCoreAPI: 39,
    AddressClassCoreAPI: 63,
    ContactAssociationTicketAPI: 6,
    StageGroupIDTicketAPI: 5,
    AllTypeCoreAPI: 35,
    UserTypesTerritoryAPI: 2,
    CompanyBranchGroupId: 190,
    CompanyBranchTypeId: 100,
    SocialTypeAccountAPI: 12,
    EmailTypeId: 11,
    PhoneTypeId: 10,
    contactRolesId: 1241,
}
